import { Typography } from 'antd';
import './AllocationGrid.mobile.css';

export interface AllocationTotal {
  label: string;
  value: string;
  /** `warn` — значение выделяется красным (например, разнесено больше суммы). */
  tone?: 'warn';
}

/**
 * Итоги разнесения (сумма платежа, разнесено, остаток) — липкая полоса сверху окна на телефоне: при
 * прокрутке длинного списка документов она остаётся на виду, и видно, сколько ещё не разнесено.
 * Только для телефона — на десктопе итоги видны в заголовках сеток.
 */
export function AllocationTotals({ items, note }: { items: AllocationTotal[]; note?: string }) {
  return (
    <div className="alloc-totals" role="status">
      {items.map((item) => (
        <span key={item.label}>
          <Typography.Text type="secondary">{item.label}: </Typography.Text>
          <Typography.Text strong className="tabular-nums" style={item.tone === 'warn' ? { color: '#cf1322' } : undefined}>
            {item.value}
          </Typography.Text>
        </span>
      ))}
      {note ? (
        <Typography.Text type="secondary" className="alloc-totals__note">
          {note}
        </Typography.Text>
      ) : null}
    </div>
  );
}
